<template>
  <section>
    <!-- <h2>A escola possui</h2> -->
    <ul>
      <li v-for="(o, i) in locais" :key="i">
        <i class="fas fa-check"></i>
        {{o.title}}
      </li>
      <li><small>...e muito mais. Venha fazer uma visita!</small></li>
    </ul>
  </section>
</template>

<script>
export default {
  data: () => ({
    // itens usando card com fotos
    locais: [
      { title: "Sala de informática", icon: "" },
      { title: "Parque infantil", icon: "" },
      { title: "Quadra poliesportiva coberta", icon: "" },
      { title: "Biblioteca", icon: "local_library" },
      { title: "Laboratório de ciências", icon: "" },
      { title: "Sala de artes", icon: "palette" },
      { title: "Sala multiuso", icon: "" }
    ]
  })
};
</script>

<style lang="scss" scoped>
i {
  color: #f48120;
}
ul {
  list-style: none;
  padding: 0;
  li {
    font-size: 1.5em;
  }
}
p {
  text-align: center;
}
</style>
